import { Component } from 'react';

export class BusinessPlanSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;
        return (
            <svg
                className={className}
                width="40"
                height="31"
                viewBox="0 0 40 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7 23L17.6957 11.5625L22.2609 16.375L31 7"
                    stroke="#1F4264"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M34.0341 3.48486C34.4225 3.35882 34.79 3.72636 34.664 4.11477L32.8652 9.6581C32.75 10.0133 32.3002 10.1214 32.0361 9.85733L28.2915 6.11275C28.0275 5.84869 28.1356 5.39887 28.4908 5.28361L34.0341 3.48486Z"
                    fill="#1F4264"
                />
                <line
                    x1="4"
                    y1="3"
                    x2="4"
                    y2="30"
                    stroke="#C7E5D1"
                    strokeWidth="2"
                />
                <path d="M40 29.5L3 29.5" stroke="#C7E5D1" strokeWidth="2" />
                <line x1="1" x2="1" y2="27" stroke="#1F4264" strokeWidth="2" />
                <path d="M37 26.5L0 26.5" stroke="#1F4264" strokeWidth="2" />
            </svg>
        );
    }
}
